const fileStore = new Map();

export const storeJobFiles = (jobId, files) => {
  fileStore.set(jobId, files);
};

export const getJobFiles = (jobId) => fileStore.get(jobId);

export const clearJobFiles = (jobId) => {
  fileStore.delete(jobId);
};
